import { AppModule } from 'app/module';
import { userWatchlist } from 'app/userWatchlist';

import './styles.scss';
import Template from './template.hbs';

export class WatchlistLoginInfo extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            closeButton: '.m-watchlistLoginInfo__close',
            loginLink: '.m-watchlistLoginInfo__anchor',
        };
    }

    domEvents() {
        if (this.dom.closeButton) {
            this.dom.closeButton.addEventListener('click', (e) => this.closeButtonClicked(e));
        }

        if (this.dom.loginLink) {
            this.dom.loginLink.addEventListener('click', (e) => this.loginLinkClicked(e));
        }

        userWatchlist.events.on('onUnauthorized', (watchlistObject) => this.openWatchlistInfo(watchlistObject));
    }

    loginLinkClicked(e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        const href = this.dom.loginLink.getAttribute('data-href');
        window.location.href = href;
    }

    closeButtonClicked(e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        this.events.emit('onCloseButtonClicked');
    }

    openWatchlistInfo(watchlistObject) {
        if (this.props.id === watchlistObject.arguments[0].watchlistObject.id) {
            this.updateProps({ visible: true, state: watchlistObject.arguments[0].watchlistObject.state }, true);
        }
    }
}
